(() => {
  if (window.__evanoHomeCollectionNavReady) return;
  window.__evanoHomeCollectionNavReady = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-evano-collection-entry]');
    if (!link) return;

    const destination = new URL(link.href);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'home_collection_click',
      collection_path: destination.pathname,
      link_label: link.textContent.trim(),
      placement: link.dataset.evanoCollectionPlacement || 'unknown',
      position: Number(link.dataset.evanoCollectionPosition || 0)
    });
  });
})();
